
import React from 'react';
import { Accordion, AccordionSummary, AccordionDetails, Typography,Box } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DriverNavBar from '../../Components/NavigationBar/DriverNavBar';
import DriverAttendanceGateKeeper from '../../Components/Driver/DriverAttendanceGateKeeper';

function DriverGateKeeper() {
    

  return (
    <DriverNavBar>
      <Box sx={{ width: '100%' }}>
        <DriverAttendanceGateKeeper></DriverAttendanceGateKeeper>
      </Box>
    </DriverNavBar>
  );
}

export default DriverGateKeeper;
